import request from '@/utils/request'

export function meetStoryCategoryList(data) {
    return request({
        url: '/backend/story/meetStoryCategoryList',
        method: 'post',
        data: data
    })
}

export function createUpdateMeetStoryCategory(data) {
    return request({
        url: '/backend/story/createUpdateMeetStoryCategory',
        method: 'post',
        data: data
    })
}

export function meetStoryCategoryInfo(data) {
    return request({
        url: '/backend/story/meetStoryCategoryInfo',
        method: 'post',
        data: data
    })
}

export function deleteMeetStoryCategory(data) {
    return request({
        url: '/backend/story/deleteMeetStoryCategory',
        method: 'post',
        data: data
    })
}